import { env } from "@monorepo/env/dashboard";

export const BFF_URL = env.VITE_EXPERIENCE_API_URL;
export const ACCOUNT_UI_URL = env.VITE_ACCOUNT_UI_URL;

export const HIDDEN_TOOLKITS = new Set([
  "google",
  "microsoft",
  "search",
  "web",
  "codesandbox",
  "outlookcalendar",
  "outlookmail",
  "sharepoint",
]);
